import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { CONFIG_KEYS } from 'FormsUI/constants/RichText';

// for IE11 compatibility https://issues.hubspotcentral.com/browse/CRM-17134
export const secureDocument = document.implementation.createHTMLDocument('sanitize');
const COMMON_CONFIG = {
  dom: secureDocument,
  remove_contents: ['script', 'style', 'title']
};

// should match https://git.hubteam.com/HubSpotProtected/Forms/blob/master/FormsBase/src/main/java/com/hubspot/forms/base/utils/SafeLists.java#L14
const SIMPLE_CONFIG = Object.assign({}, COMMON_CONFIG, {
  elements: ['a', 'b', 'br', 'em', 'i', 'p', 'span', 'strong', 'u', 'span'],
  attributes: {
    __ALL__: ['dir'],
    a: ['href', 'target', 'rel', 'name', 'linktext', 'tabindex', 'title', 'data-insert'],
    span: ['style']
  },
  protocols: {
    a: {
      href: ['http', 'https', 'mailto', 'tel']
    }
  }
});

// should match https://git.hubteam.com/HubSpotProtected/Forms/blob/master/FormsBase/src/main/java/com/hubspot/forms/base/utils/SafeLists.java#L31
const INLINE_MESSAGE_SAFELIST = Object.assign({}, COMMON_CONFIG, {
  elements: ['a', 'b', 'br', 'em', 'i', 'p', 'span', 'strong', 'u', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'div', 'pre', 'blockquote', 'sup', 'sub', 'code', 'iframe', 'hr', 'table', 'tr', 'td', 'tbody'],
  attributes: {
    __ALL__: ['dir', 'style', 'class', 'title'],
    a: ['id', 'href', 'target', 'rel', 'name', 'linktext', 'tabindex', 'title', 'data-insert', 'data-hs-anchor'],
    img: ['src', 'style', 'alt', 'loading', 'width', 'height'],
    div: ['data-hs-responsive-table', 'data-service', 'data-responsive', 'data-script-embed'],
    iframe: ['src', 'width', 'height', 'border', 'scrolling']
  },
  protocols: {
    a: {
      href: ['http', 'https', 'mailto', 'tel']
    },
    img: {
      src: ['http', 'https']
    },
    iframe: {
      src: ['http', 'https']
    }
  }
});

// should match https://git.hubteam.com/HubSpotProtected/Forms/blob/master/FormsBase/src/main/java/com/hubspot/forms/base/utils/SafeLists.java#L92
const RICH_TEXT_SAFELIST = Object.assign({}, COMMON_CONFIG, {
  elements: ['a', 'b', 'i', 'u', 'strike', 'em', 'strong', 'img', 'p', 'br', 'ol', 'ul', 'li', 'sub', 'sup', 'blockquote', 'hr', 'div', 'span', 'pre', 'code', 'table', 'tbody', 'tr', 'td', 'th', 'caption', 'colgroup', 'col', 'fieldset', 'legend', 'font', 'label', 'center', 'big', 'iframe', 'abbr', 'section', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'tt', 'dl', 'dt', 'dd'],
  attributes: {
    __ALL__: ['style', 'class', 'id', 'color', 'align', 'size', 'lang', 'dir', 'valign'],
    table: ['cellspacing', 'cellpadding', 'bgcolor', 'border'],
    font: ['face', 'width'],
    label: ['for'],
    a: ['href', 'target', 'rel', 'name', 'linktext', 'tabindex', 'title', 'data-insert'],
    img: ['src', 'style', 'alt', 'width', 'height', 'halign', 'border', 'title', 'data-constrained', 'data-gai', 'data-img-width', 'data-img-height', 'data-img-aspect-ratio', 'caption', 'loading'],
    iframe: ['src', 'width', 'height', 'border', 'scrolling'],
    span: ['style']
  },
  protocols: {
    a: {
      href: ['http', 'https', 'mailto', 'tel']
    },
    img: {
      src: ['http', 'https']
    },
    iframe: {
      src: ['http', 'https']
    }
  }
});
const CONFIG = {
  [CONFIG_KEYS.GDPR]: SIMPLE_CONFIG,
  [CONFIG_KEYS.LABEL]: SIMPLE_CONFIG,
  [CONFIG_KEYS.SUBMIT]: SIMPLE_CONFIG,
  [CONFIG_KEYS.THANKYOU]: INLINE_MESSAGE_SAFELIST,
  [CONFIG_KEYS.BASE]: RICH_TEXT_SAFELIST
};
export const sanitizeHTML = (html, configKey = CONFIG_KEYS.BASE) => {
  const config = CONFIG[configKey];
  if (!config) {
    return html;
  }
  return sanitize(html, config);
};